var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagsEmptyState(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  props = _objectSpread({
    title: ''
  }, props);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 251 74",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#cad5db",
    height: 40,
    rx: 20,
    width: 171
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f1faff",
    height: 40,
    rx: 20,
    width: 171,
    x: 80,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#cad5db",
    height: 12,
    rx: 6,
    width: 112,
    x: 100,
    y: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231 52.821 6.91-6.91a.833.833 0 0 1 1.18 1.178L232.178 54l6.91 6.91a.833.833 0 1 1-1.178 1.18L231 55.178l-6.91 6.91a.833.833 0 0 1-1.18-1.178l6.912-6.91-6.91-6.91a.833.833 0 1 1 1.178-1.18z",
    fill: "#cad5db"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f5f8fa",
    height: 12,
    rx: 6,
    width: 132,
    x: 20,
    y: 14
  }))));
}
export { SvgTagsEmptyState as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjUxIDc0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCBmaWxsPSIjY2FkNWRiIiBoZWlnaHQ9IjQwIiByeD0iMjAiIHdpZHRoPSIxNzEiLz4KICAgICAgICA8cmVjdCBmaWxsPSIjZjFmYWZmIiBoZWlnaHQ9IjQwIiByeD0iMjAiIHdpZHRoPSIxNzEiIHg9IjgwIiB5PSIzNCIvPgogICAgICAgIDxyZWN0IGZpbGw9IiNjYWQ1ZGIiIGhlaWdodD0iMTIiIHJ4PSI2IiB3aWR0aD0iMTEyIiB4PSIxMDAiIHk9IjQ4Ii8+CiAgICAgICAgPHBhdGggZD0ibTIzMSA1Mi44MjEgNi45MS02LjkxYS44MzMuODMzIDAgMCAxIDEuMTggMS4xNzhMMjMyLjE3OCA1NGw2LjkxIDYuOTFhLjgzMy44MzMgMCAxIDEtMS4xNzggMS4xOEwyMzEgNTUuMTc4bC02LjkxIDYuOTFhLjgzMy44MzMgMCAwIDEtMS4xOC0xLjE3OGw2LjkxMi02LjkxLTYuOTEtNi45MWEuODMzLjgzMyAwIDEgMSAxLjE3OC0xLjE4eiIgZmlsbD0iI2NhZDVkYiIvPgogICAgICAgIDxyZWN0IGZpbGw9IiNmNWY4ZmEiIGhlaWdodD0iMTIiIHJ4PSI2IiB3aWR0aD0iMTMyIiB4PSIyMCIgeT0iMTQiLz4KICAgIDwvZz4KPC9zdmc+";